if (!customElements.get('hoculus-cookie-banner')) {
    class HoculusCookieBanner extends HTMLElement {
        constructor() {
            super();
            this.refuseButton = this.querySelector(".refuse-cookies");
            this.acceptButton = this.querySelector(".accept-cookies");
            this.manageButton = this.querySelector(".manage-cookies");
            this.preferencesPopup = document.querySelector("#" + this.dataset.popup);
        }
        connectedCallback() {
            this.refuseButton.addEventListener('click', () => {
                this.preferencesPopup.rejectAllCookies();
                this.closeBanner();
            });

            this.acceptButton.addEventListener('click', () => {
                this.preferencesPopup.acceptAllCookies()
                this.closeBanner();
            });

            this.manageButton.addEventListener('click', () => this.openPreferences());
        }
        openPreferences() { this.preferencesPopup.openPopup() }
        openBanner() { this.classList.remove("d-none") }
        closeBanner() { this.classList.add("d-none") }
    }

    customElements.define("hoculus-cookie-banner", HoculusCookieBanner);
}